import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image
} from '@react-pdf/renderer';
import BrandImage from '../../../../../../assets/images/UTP.png';

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 8,
    textAlign: 'left'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 20,
    paddingBottom: 10
  },
  logo: {
    width: 120
  },
  dateSection: {
    textAlign: 'right',
    fontSize: 8,
    marginTop: 5
  },
  dateSectionDate: {
    marginBottom: 10
  },
  titleSection: {
    textAlign: 'center',
    textDecoration: 'underline',
    marginBottom: 20,
    fontSize: 9
  },
  academicPlanSection: {
    textAlign: 'center',
    fontSize: 7,
    marginBottom: 10
  },
  information: {
    marginBottom: 10,
    flexDirection: 'row',
    fontSize: 7
  },
  subtitle: {
    fontFamily: 'Helvetica-Bold',
    width: '35%',
    textAlign: 'left'
  },
  subtitleCredits: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 8
  },
  infoText: {
    width: '55%',
    textAlign: 'left'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: 20,
    marginBottom: 20
  },
  row: {
    flexDirection: 'row'
  },
  headerCell: {
    backgroundColor: '#74569E',
    padding: 4,
    fontSize: 7,
    border: 'none',
    textAlign: 'center',
    color: 'white'
  },
  subHeaderCell: {
    backgroundColor: '#BED3E2',
    padding: 4,
    fontSize: 8,
    border: 'none',
    textAlign: 'left',
    fontFamily: 'Helvetica-Bold'
  },
  colspanCell: { width: '100%' },
  cell: {
    padding: 4,
    fontSize: 7,
    border: 'none',
    textAlign: 'left'
  },
  colCiclo: {
    width: '9%',
    textAlign: 'center'
  },
  colCode: {
    width: '10%'
  },
  colName: {
    width: '37%',
    textAlign: 'left'
  },
  colNumberTimes: {
    width: '9%',
    textAlign: 'center'
  },
  colCredits: {
    width: '9%',
    textAlign: 'center'
  },
  colGrade: {
    width: '9%',
    textAlign: 'center'
  },
  colSection: {
    width: '9%',
    textAlign: 'center'
  },
  colStatus: {
    width: '10%',
    textAlign: 'right',
    paddingRight: 8
  }
});
const PdfDocument = ({
  academicPlan,
  data,
  fullName,
  program,
  studentCode,
  totalCredits
}: any) => {
  const now = new Date();
  const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(
    now.getMonth() + 1
  )
    .toString()
    .padStart(2, '0')}/${now.getFullYear()}`;
  const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now
    .getMinutes()
    .toString()
    .padStart(2, '0')}`;

  return (
    <Document>
      <Page style={styles.page}>
        {/* Header con logo y fecha */}
        <View style={styles.header}>
          <Image style={styles.logo} src={BrandImage} />
          <View style={styles.dateSection}>
            <Text style={styles.dateSectionDate}>Fecha: {formattedDate}</Text>
            <Text>Hora: {formattedTime}</Text>
          </View>
        </View>

        {/* Título y Plan Académico */}
        <Text style={styles.titleSection}>RECORD DE NOTAS</Text>

        {/* Información del estudiante */}
        <View>
          <View style={styles.information}>
            <Text style={styles.subtitle}>Alumno(a): </Text>
            <Text>{fullName}</Text>
          </View>
          <View style={styles.information}>
            <Text style={styles.subtitle}>Código: </Text>
            <Text>{studentCode}</Text>
          </View>
          <View style={styles.information}>
            <Text style={styles.subtitle}>Programa: </Text>
            <Text>{program}</Text>
          </View>
          <View style={styles.information}>
            <Text style={styles.subtitle}>Plan de Estudio: </Text>
            <Text>{academicPlan}</Text>
          </View>
          <View style={styles.information}>
            <Text style={styles.subtitle}>Resumen de Créditos: </Text>
            <Text>
              Aprobado{' '}
              <span style={styles.subtitleCredits}>
                {totalCredits.toFixed(2)}
              </span>{' '}
            </Text>
          </View>
        </View>

        {/* Tabla de ciclos y cursos */}
        <View style={styles.table}>
          <View style={styles.row}>
            <Text style={[styles.headerCell, styles.colCiclo]}>CICLO</Text>
            <Text style={[styles.headerCell, styles.colCode]}>COD CURSO</Text>
            <Text style={[styles.headerCell, styles.colName]}>CURSO</Text>
            <Text style={[styles.headerCell, styles.colNumberTimes]}>
              NRO VEZ
            </Text>
            <Text style={[styles.headerCell, styles.colCredits]}>CRÉDITOS</Text>
            <Text style={[styles.headerCell, styles.colGrade]}>NOTA</Text>
            <Text style={[styles.headerCell, styles.colSection]}>SECCIÓN</Text>
            <Text style={[styles.headerCell, styles.colStatus]}>ESTADO</Text>
          </View>

          {data?.map((cycle: any) => (
            <React.Fragment key={cycle?.name}>
              <View style={styles.row}>
                <View style={[styles.subHeaderCell, styles.colspanCell]}>
                  <Text>{cycle?.name}</Text>
                </View>
              </View>
              {cycle.items.map((course: any) => (
                <View style={styles.row} key={course.catalogNumber}>
                  <Text style={[styles.cell, styles.colCiclo]}>
                    {course.cycle}
                  </Text>
                  <Text style={[styles.cell, styles.colCode]}>
                    {course.catalogNumber}
                  </Text>
                  <Text style={[styles.cell, styles.colName]}>
                    {course.courseName}
                  </Text>
                  <Text style={[styles.cell, styles.colNumberTimes]}>
                    {course.numberTimes === 'null' ? '--' : course.numberTimes}
                  </Text>
                  <Text style={[styles.cell, styles.colCredits]}>
                    {course.credits}
                  </Text>
                  <Text style={[styles.cell, styles.colGrade]}>
                    {course.grade === ' ' ? '--' : course.grade}
                  </Text>
                  <Text style={[styles.cell, styles.colSection]}>
                    {course.section}
                  </Text>
                  <Text style={[styles.cell, styles.colStatus]}>
                    {course.approvalStatus}
                  </Text>
                </View>
              ))}
            </React.Fragment>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default PdfDocument;
